import { ReferenceCustomerFragment, ReservationDetailFragment } from 'src/api/api.generated'
import { ReservationF, ReservedResourceF } from '../types/reservation-detail.types'
import { getReservedResourceF } from './reserved-resource'

export function getReservationF(hotelDate: Date, reservation: ReservationDetailFragment | null | undefined): ReservationF | null | undefined {
  if (reservation === null) {
    return null
  }
  if (reservation === undefined) {
    return undefined
  }

  const reservedResources: ReservedResourceF[] = []

  reservation.reservedResources?.forEach((rr) => {
    const reservedResource = getReservedResourceF(hotelDate, reservation, rr.id)
    if (reservedResource) {
      reservedResources.push(reservedResource)
    }
  })

  const minStart = reservedResources
    ?.map((r) => r.start)
    ?.reduce((previousValue: Date | undefined, currentValue: Date) => (previousValue && previousValue <= currentValue ? previousValue : currentValue), undefined)

  const maxEnd = reservedResources
    ?.map((r) => r.end)
    ?.reduce((previousValue: Date | undefined, currentValue: Date) => (previousValue && previousValue >= currentValue ? previousValue : currentValue), undefined)

  const reservationGuestTotal: { adults: number; children: number } = reservedResources.reduce(
    (total, rr) => {
      return {
        adults: total.adults + rr.adults,
        children: total.children + rr.children,
      }
    },
    { adults: 0, children: 0 },
  )

  const guestsIn = reservedResources.reduce((sum, rr) => {
    const guestOccupancyWithoutCheckin =
      rr.guestOccupancies?.reduce((sumGO, go) => {
        return sumGO + (go.phase === 'CHECKIN' ? 1 : 0)
      }, 0) ?? 0
    return sum + guestOccupancyWithoutCheckin
  }, 0)

  const guestsWithoutCheckin = reservationGuestTotal.adults + reservationGuestTotal.children - guestsIn

  const rrInPhaseReservation = reservation.reservedResources?.find((rr) => rr.phase === 'RESERVATION') !== undefined
  const rrInPhaseCheckin = reservation.reservedResources?.find((rr) => rr.phase === 'CHECKIN') !== undefined

  const checkInEnabled = rrInPhaseReservation && minStart && maxEnd && minStart <= hotelDate && maxEnd >= hotelDate && guestsWithoutCheckin > 0
  const checkOutEnabled = rrInPhaseCheckin

  const customerReferenceList: ReferenceCustomerFragment[] = [{ ...reservation.reference.mainGuest }]
  if (reservation.reference.customerPerson) {
    customerReferenceList.push({ ...reservation.reference.customerPerson })
  }

  if (reservation.reference.customerCompany) {
    customerReferenceList.push({ ...reservation.reference.customerCompany })
  }
  if (reservation.reference.agency) {
    customerReferenceList.push({ ...reservation.reference.agency })
  }

  const webCheckinEnabled = !reservation.isGroup /*  && (reservation.reservedResources?.every((rr) => rr.phase === 'RESERVATION') ?? false) */

  return { ...reservation, reservedResources, minStart, maxEnd, checkInDisabled: !checkInEnabled, checkOutDisabled: !checkOutEnabled, customerReferenceList: customerReferenceList, webCheckinEnabled }
}
